module.exports = __webpack_public_path__ + "static/media/absence.83365fc3.svg";